/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1CreditCard } from '../models/V1CreditCard';
import { HttpFile } from '../http/http';

/**
* ListCreditCardsResponse
*/
export class V1ListCreditCardsResponse {
    /**
    * List of credit cards
    */
    'creditCards'?: Array<V1CreditCard>;
    /**
    * The total number of credit cards on all pages
    */
    'totalSize'?: number;
    /**
    *  A token, which can be sent as `page_token`, to retrieve the next page. If omitted, there are no subsequent pages
    */
    'nextPageToken'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creditCards",
            "baseName": "credit_cards",
            "type": "Array<V1CreditCard>",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListCreditCardsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

